/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trigger_ScheduleInputs */

const cs_trigger_schedule = /** @type {(inputs: Trigger_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plán`)
};

const en_trigger_schedule = /** @type {(inputs: Trigger_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {Trigger_ScheduleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const trigger_schedule = /** @type {((inputs?: Trigger_ScheduleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trigger_ScheduleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trigger_schedule(inputs)
	return cs_trigger_schedule(inputs)
});